import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GlobalStyles } from "./styles/GlobalStyles";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Works from "./pages/Works";
import ProjectDetail from "./pages/ProjectDetail";
import Contacts from "./pages/Contacts";
import Admin from "./pages/Admin";
import AdminDashboard from "./pages/AdminDashboard";
import Product from "./pages/Product";
import PR from "./pages/PR";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import { Video } from "./types";
import VideoModal from "./components/VideoModal";
import YouTubeModal from "./components/YouTubeModal";

// Remove placeholder component since we now import Works

// Mock data for demonstration - CRESTU style content
const mockVideos: Video[] = [
    {
        id: "1",
        title: "클라이언트 운영 가이드",
        description: "효율적인 클라이언트 운영을 위한 기본 가이드입니다.",
        thumbnail: "https://via.placeholder.com/400x300/333/ffffff?text=Guide",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "가이드",
        createdAt: "2024-01-15",
    },
    {
        id: "2",
        title: "시스템 관리 팁",
        description: "시스템을 안정적으로 관리하는 방법을 알아보세요.",
        thumbnail: "https://via.placeholder.com/400x300/666/ffffff?text=System",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "시스템",
        createdAt: "2024-01-10",
    },
    {
        id: "3",
        title: "보안 설정 방법",
        description: "클라이언트 보안을 강화하는 설정 방법을 소개합니다.",
        thumbnail: "https://via.placeholder.com/400x300/999/ffffff?text=Security",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "보안",
        createdAt: "2024-01-05",
    },
    {
        id: "4",
        title: "데이터베이스 최적화",
        description: "MariaDB 데이터베이스 성능 최적화 방법을 알아보세요.",
        thumbnail: "https://via.placeholder.com/400x300/333/ffffff?text=Database",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "데이터베이스",
        createdAt: "2024-01-01",
    },
    {
        id: "5",
        title: "API 개발 가이드",
        description: "RESTful API 개발 및 관리 방법을 소개합니다.",
        thumbnail: "https://via.placeholder.com/400x300/666/ffffff?text=API",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "API",
        createdAt: "2023-12-28",
    },
    {
        id: "6",
        title: "배포 및 운영",
        description: "AWS EC2를 활용한 서버 배포 및 운영 방법을 알아보세요.",
        thumbnail: "https://via.placeholder.com/400x300/999/ffffff?text=Deploy",
        videoUrl: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
        category: "배포",
        createdAt: "2023-12-25",
    },
];

interface Content {
    id: number;
    title: string;
    description: string;
    content_type: "works" | "product" | "pr" | "hero_video";
    category: string;
    youtube_url: string;
    youtube_id: string;
    thumbnail_url: string;
    duration: string;
    published_at: string;
    view_count: number;
    like_count: number;
    custom_thumbnail: string;
    custom_description: string;
    custom_published_at: string;
    is_active: boolean;
    sort_order: number;
    created_at: string;
    updated_at: string;
}

function AppContent() {
    const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
    const [selectedContent, setSelectedContent] = useState<Content | null>(null);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const [isYouTubeModalOpen, setIsYouTubeModalOpen] = useState(false);

    const handleVideoSelect = (video: Video) => {
        setSelectedVideo(video);
        setIsVideoModalOpen(true);
    };

    const handleContentSelect = (content: Content) => {
        setSelectedContent(content);
        setIsYouTubeModalOpen(true);
    };

    const handleCloseVideoModal = () => {
        setIsVideoModalOpen(false);
        setSelectedVideo(null);
    };

    const handleCloseYouTubeModal = () => {
        setIsYouTubeModalOpen(false);
        setSelectedContent(null);
    };

    return (
        <div className="App">
            <Header videos={mockVideos} onVideoSelect={handleVideoSelect} onContentSelect={handleContentSelect} />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/works" element={<Works />} />
                <Route path="/works/:category" element={<Works />} />
                <Route path="/works/detail/:id" element={<ProjectDetail />} />
                <Route path="/contacts" element={<Contacts />} />
                {/* Product and PR pages are hidden from navigation but still accessible via direct URL */}
                <Route path="/product" element={<Product />} />
                <Route path="/pr" element={<PR />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin-old" element={<AdminDashboard />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
            </Routes>
            <Footer />
            <VideoModal video={selectedVideo} isOpen={isVideoModalOpen} onClose={handleCloseVideoModal} />
            <YouTubeModal content={selectedContent} isOpen={isYouTubeModalOpen} onClose={handleCloseYouTubeModal} />
        </div>
    );
}

function App() {
    return (
        <Router>
            <GlobalStyles />
            <AppContent />
        </Router>
    );
}

export default App;
